/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutPickupViewProps } from './lds-checkout-pickup-4';
import { ICheckoutPickupGroupViewProps } from './components/lds-checkout-pickup-4-group';
import { getTimeslot } from './components';
import styled from 'styled-components';

const CheckoutPickupView: React.FC<ICheckoutPickupViewProps> = props => {
    const { checkoutPickup, checkoutErrorRef, viewState, headerError, waiting, pickupGroups } = props;
    const SectionHeader = styled.div`
    display: flex;
    font-family: Ensign:Sans;
    font-size: 18px;
    font-weight: bold;
    `;
    // color: #212225;

    return (
        <Module {...checkoutPickup} ref={checkoutErrorRef}>
            {viewState.isLoading && waiting}
            {viewState.isHeaderError && headerError}
            {pickupGroups.map(
                (pickupGroupViewProps: ICheckoutPickupGroupViewProps, index: number): React.ReactElement => {
                    const {
                        pickupGroupContainer,
                        dateTimeslotContainer,
                        groupDivider,
                        groupHeader,
                        groupErrorMessage,
                        // cartLineImages,
                        pickupDateDropdown,
                        pickupTimeslotDropdown,
                        selectedDateTimeslot,
                        pickupAddress
                    } = pickupGroupViewProps;
                    const options: any = {
                        timeZone: 'UTC',
                        dateStyle: 'full'
                    };

                    const dateFormateLocale = props.context.request.locale === 'en-US' ? 'en-GB' : props.context.request.locale;
                    const formatter = new Intl.DateTimeFormat(dateFormateLocale, options);
                    // return formatter.format(new Date(date));
                    let selectedTimeSlot: any;
                    if (
                        pickupTimeslotDropdown &&
                        // @ts-ignore
                        pickupTimeslotDropdown.props &&
                        // @ts-ignore
                        pickupTimeslotDropdown.props.selectedTimeslot &&
                        // @ts-ignore
                        pickupTimeslotDropdown.props.selectedTimeslot.StartDateTime
                    ) {
                        selectedTimeSlot = getTimeslot(
                            props.resources.pickupTimeslotPlaceHolder,
                            // @ts-ignore
                            pickupTimeslotDropdown.props.selectedTimeslot.StartDateTime || '',
                            // @ts-ignore
                            pickupTimeslotDropdown.props.selectedTimeslot.EndDateTime || '',
                            props.context.request.locale
                        );
                    }

                    return (
                        <Node {...pickupGroupContainer} key={`checkout-pickup-group-${index}`}>
                            {groupDivider}
                            {/* @ts-ignore */}
                            <SectionHeader>{groupHeader.props.storeInfo}</SectionHeader>
                            {/* {groupHeader} */}
                            {groupErrorMessage}
                            {/* {cartLineImages} */}
                            {viewState.isShowDropdown && (
                                <Node {...dateTimeslotContainer}>
                                    {pickupDateDropdown}
                                    {pickupTimeslotDropdown}
                                </Node>
                            )}
                            {viewState.isShowSelected && pickupAddress}
                            {/* {viewState.isShowSelected && selectedDateTimeslot} */}
                            {/* <div>{moment(pickupTimeslotStartDateTime).format('dddd, D MMMM YYYY')}</div> */}
                            {viewState.isShowSelected &&
                                pickupTimeslotDropdown &&
                                // @ts-ignore
                                pickupTimeslotDropdown.props &&
                                // @ts-ignore
                                pickupTimeslotDropdown.props.selectedTimeslot &&
                                // @ts-ignore
                                pickupTimeslotDropdown.props.selectedTimeslot.StartDateTime &&
                                // @ts-ignore
                                pickupTimeslotDropdown.props.selectedTimeslot.EndDateTime && (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {/* @ts-ignore */}
                                        <span
                                            style={{
                                                fontFamily: 'Ensign:Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 600,
                                                fontSize: '18px',
                                                lineHeight: '22px',
                                                paddingBottom: '8px'
                                            }}
                                        >
                                            {/* @ts-ignore */}
                                            {selectedDateTimeslot.props.title}
                                        </span>
                                        <span
                                            style={{
                                                fontFamily: 'Ensign:Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                lineHeight: '19px'
                                            }}
                                        >
                                            {/* @ts-ignore */}
                                            {formatter.format(new Date(pickupTimeslotDropdown.props.selectedTimeslot.StartDateTime))}
                                        </span>
                                        <span
                                            style={{
                                                fontFamily: 'Ensign:Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                lineHeight: '19px'
                                            }}
                                        >
                                            {selectedTimeSlot || ''}
                                        </span>
                                        {/* @ts-ignore */}
                                        {/* {moment(pickupTimeslotDropdown.props.selectedTimeslot.StartDateTime).format('LT')} -{' '} */}
                                        {/* @ts-ignore */}
                                        {/* {moment(pickupTimeslotDropdown.props.selectedTimeslot.EndDateTime).format('LT')} */}
                                    </div>
                                )}
                        </Node>
                    );
                }
            )}
        </Module>
    );
};

export default CheckoutPickupView;
